<div *ngFor="let contentBlock of contents" [ngSwitch]="contentBlock.__typename">
  <!-- Subheading -->
  <div *ngSwitchCase="'ComponentArticleComponentsSubheading'" class="content-subheading">{{ contentBlock.subheadingText }}</div>
  <!-- Paragraph -->
  <div *ngSwitchCase="'ComponentArticleComponentsParagraph'" style="margin: 1rem 0rem;">
    <div [innerHtml]="contentBlock.paragraphText" [class.warning-paragraph]="contentBlock.variant === 'Warning'"></div>
  </div>
  <!-- Video -->
  <div class="video-container" *ngSwitchCase="'ComponentArticleComponentsVideo'" style="margin: 1rem 0rem;">
    <iframe #video [src]="contentBlock.videoUrl.trim() + youtubeEmbedParms | safe: 'resourceUrl'" frameborder="0" allow="autoplay; encrypted-media;" allowfullscreen></iframe>
  </div>
  <!-- Image (Full Width) -->
  <div *ngSwitchCase="'ComponentArticleComponentsImageFullWidth'" class="content-image-fullwidth">
    <div *ngIf="contentBlock.image" class="image-wrapper">
      <pinch-zoom backgroundColor="white" [zoomControlScale]="0.6" disableZoomControl="never" [wheel]="false">
        <img
          [src]="contentBlock.image.url"
          [alt]="contentBlock.image.alternativeText ?? ''"
        />
      </pinch-zoom>
      <div *ngIf="contentBlock.image.caption" class="content-image-caption">{{ contentBlock.image.caption }}</div>
    </div>
  </div>
</div>